import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard, 
  Users, 
  Wallet, 
  CheckSquare, 
  UserPlus, 
  CreditCard, 
  Package, 
  FileText,
  Settings,
  LogOut,
  ChevronRight,
  BarChart3,
  CalendarDays,
  ClipboardList,
  Clock,
  StickyNote,
  GanttChart,
  UserCog,
  ArrowDownUp
} from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_44ec93c6-a1ed-4add-8620-bb53ad1de93f/artifacts/fo7gzvnl_2.png";

const Layout = ({ children }) => {
  const { user, logout, isDirection } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { 
      to: '/', 
      icon: LayoutDashboard, 
      label: 'Dashboard',
      visible: true 
    },
    { 
      to: '/dashboard-direccion', 
      icon: BarChart3, 
      label: 'Dashboard Dirección',
      visible: isDirection() 
    },
    { 
      to: '/flujo', 
      icon: ArrowDownUp, 
      label: 'Flujo',
      visible: isDirection() 
    },
    { 
      to: '/clientes', 
      icon: Users, 
      label: 'Clientes',
      visible: true 
    },
    { 
      to: '/caja', 
      icon: Wallet, 
      label: 'Caja',
      visible: true 
    },
    { 
      to: '/casos-operativos', 
      icon: ClipboardList, 
      label: 'Control Mensual',
      visible: true 
    },
    { 
      to: '/tareas', 
      icon: CheckSquare, 
      label: 'Tareas',
      visible: true 
    },
    { 
      to: '/leads', 
      icon: UserPlus, 
      label: 'Leads',
      visible: true 
    },
    { 
      to: '/pagos-rechazados', 
      icon: CreditCard, 
      label: 'Pagos Rechazados',
      visible: true 
    },
    { 
      to: '/inventario', 
      icon: Package, 
      label: 'Inventario',
      visible: true 
    },
    { 
      to: '/reportes', 
      icon: FileText, 
      label: 'Reportes',
      visible: isDirection() 
    },
    { 
      to: '/calendario', 
      icon: CalendarDays, 
      label: 'Calendario',
      visible: true 
    },
    { 
      to: '/horas-profesores', 
      icon: Clock, 
      label: 'Horas Profesores',
      visible: isDirection() 
    },
    { 
      to: '/notas', 
      icon: StickyNote, 
      label: 'Notas Internas',
      visible: true 
    },
    { 
      to: '/gantt', 
      icon: GanttChart, 
      label: 'Planificación',
      visible: isDirection() 
    },
    { 
      to: '/usuarios', 
      icon: UserCog, 
      label: 'Usuarios',
      visible: isDirection() 
    },
    { 
      to: '/configuracion', 
      icon: Settings, 
      label: 'Configuración',
      visible: isDirection() 
    },
  ];

  return (
    <div className="app-layout">
      {/* Sidebar */}
      <aside className="sidebar" data-testid="sidebar">
        {/* Logo */}
        <div className="mb-8">
          <img 
            src={LOGO_URL} 
            alt="GRIT Studio" 
            className="sidebar-logo"
            data-testid="sidebar-logo"
          />
        </div>

        {/* User Info */}
        <div className="mb-6 px-3 py-2 bg-[#3D5A75] rounded-lg">
          <p className="text-sm text-[#B0C2D1]">Sesión activa</p>
          <p className="text-white font-medium truncate">{user?.name}</p>
          <p className="text-xs text-[#B0C2D1] capitalize">{user?.role === 'direccion' ? 'Dirección' : 'Recepción'}</p>
        </div>

        {/* Navigation */}
        <nav className="flex-1 space-y-1" data-testid="main-navigation">
          {navItems.filter(item => item.visible).map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `nav-item ${isActive ? 'active' : ''}`
              }
              data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <item.icon size={20} strokeWidth={1.5} />
              <span className="flex-1">{item.label}</span>
              <ChevronRight size={16} className="opacity-50" />
            </NavLink>
          ))}
        </nav>

        {/* Logout */}
        <button
          onClick={handleLogout}
          className="nav-item mt-auto text-[#B0C2D1] hover:text-white"
          data-testid="btn-logout"
        >
          <LogOut size={20} strokeWidth={1.5} />
          <span>Cerrar Sesión</span>
        </button>
      </aside>

      {/* Main Content */}
      <main className="main-content" data-testid="main-content">
        {children}
      </main>
    </div>
  );
};

export default Layout;
